
export default {
  'navbar.lang': 'isiXhosa',
  'menu.home': 'Ikhaya',
  'menu.dashboard': 'Ideshibhodi',
  'menu.profile': 'Iprofayili',
  'menu.settings': 'Useto',

  'user.login.title': 'Ukuskena kuphumelele!',
  'user.login.subtitle': 'Nceda unikeze iinkcukacha zakho ukuqhubeka',
  'user.login.username': 'Igama lomsebenzisi okanye i-imeyile',
  'user.login.password': 'Iphasiwedi',
  'user.login.forgot': 'Ukhohlwe iphasiwedi?',
  'user.login.button': 'Ngena',

  'user.register.title': 'Yenza iakhawunti entsha',
  'user.register.button': 'Bhalisa',
  'user.register.success': 'Iakhawunti yenziwe. Jonga i-imeyile ukuqinisekisa.',

  'user.login.welcome.subheading': 'Wamkelekile kwihlabathi apho inkululeko idibana nobomi obukhethekileyo! Skena. Fumana amanqaku. Phila ngokukhululekileyo. Phila ngokukhethekileyo',
  'user.login.description': 'Uskenile i-QR code yethu ngempumelelo. Ngena okanye Bhalisa ngezantsi ukuze ufumane imivuzo kunye namanqaku',
  'user.login.signin.title': 'Ngena',
  'user.login.signin.sub': 'Ukungena nceda faka inombolo yakho yefowuni; siya kuthumela ikhowudi yokuqinisekisa',
  'user.login.phoneNumberLabel': 'Inombolo yefowuni',
  'user.login.enterPhonePlaceholder': 'Faka inombolo yefowuni',
  'user.login.invalidPhone': 'Inombolo yefowuni ayichanekanga',
  'user.login.phoneRequired': 'Inombolo yefowuni iyafuneka',
  'user.login.signingIn': 'Kungena...',
  'user.login.continue': 'Qhubeka',
  'user.login.noAccount': 'Awunayo iakhawunti?',
  'user.login.signup': 'Bhalisa',
  'user.login.footerCopyright': 'Ilungelo lokushicilela © {year}. Linikezelwe yi Exceptional Brands',

  'user.register.welcome': 'Wamkelekile!',
  'user.register': 'Bhalisa ukuze ufumane imivuzo yakho',
  'user.register.description': 'Gcwalisa iinkcukacha zakho ngezantsi ukuze uzuze amanqaku, uvule imivuzo kwaye uphumelele imivuzo emangalisayo',
  'user.register.phone.label': 'Inombolo yefowuni',
  'user.register.phone.placeholder': 'Faka inombolo yefowuni',
  'user.register.phone.required': 'Inombolo yefowuni iyafuneka',
  'user.register.phone.invalid': 'Inombolo yefowuni ayichanekanga',
  'user.register.name.label': 'Igama lakho',
  'user.register.name.placeholder': 'umzekelo: Mark',
  'user.register.name.required': 'Igama liyafuneka',
  'user.register.ageGroup.label': 'Iqela leminyaka (Ukukhetha)',
  'user.register.gender.label': 'Ubungcwele (Ukukhetha)',
  'user.register.gender.male': 'Indoda',
  'user.register.gender.female': 'Umfazi',
  'user.register.terms.agreement': 'Ngokuqhubeka, uyavuma i {termsLink} kunye ne {privacyLink}.',
  'user.register.terms.termsOfService': 'Iimigaqo zenkonzo',
  'user.register.terms.privacyPolicy': 'Umgaqo wobumfihlo',
  'user.register.creating': 'Kudala iprofayili…',
  'user.register.create': 'Yenza iprofayili',
  'user.register.alreadyAccount': 'Sele unayo iakhawunti?',
  'user.register.signin': 'Ngena',

  "user.welcome.welcome": "Wamkelekile!",
  "user.welcome.welcome_name": "Wamkelekile {name}!",
  'user.welcome.points_earned': 'Siyavuyisana, ufumene',
  'user.welcome.thank_you': 'Enkosi ngokubhalisa!',
  'user.welcome.earn_more_points': 'Ukuze ufumane amanqaku amaninzi, lungisa iimveliso ezithethiweyo eziwanikezelweyo kuthi.',
  'user.welcome.continue': 'Qhubeka',
  'user.welcome.logging_in': 'Ukungena...',
  "user.welcome.welcome_reward": "Umvuzo Wokwamkela",
  "user.welcome.points_label": "amanqaku!",

  "product.button.continue": "Qhubeka",
  "product.button.selectToContinue": "Khetha imveliso ukuze uqhubeke",

  'scansuccess.review.heading': 'Ungayilinganisa njani le mveliso?',
  'scansuccess.review.continue': 'Ikhowudi yomthengisi (Kuyakhethwa)',
  'scansuccess.review.select-product': 'Yongeza ikhowudi yomthengisi ukuze ufumane amanqaku amaninzi',
  'scansuccess.review.review-products': 'Thumela Uluvo',

  "product.retailerCode.label": "Ikhowudi yomthengisi",
  "product.retailerCode.requiredLabel": "Iyafuneka",
  "product.retailerCode.optionalLabel": "Kuyakhethwa",
  "product.retailerCode.placeholder": "Faka ikhowudi yomthengisi",
  "product.retailerCode.aria": "Ikhowudi yomthengisi",
  "product.retailerCode.hintRequired": "Ikhowudi yomthengisi iyafuneka ukuze uthumele olu lwazo",
  "product.retailerCode.hintOptional": "Yongeza ikhowudi yomthengisi ukuze ufumane amanqaku amaninzi",
  "product.retailerCode.error.required": "Ikhowudi yomthengisi iyafuneka",
  "product.retailerCode.error.invalid": "Ikhowudi yomthengisi ayilunganga",

  "profile.title": "Iprofayili Yam",
  "profile.tier.member": "Ilungu",
  "profile.points": "Amanqaku",
  "profile.pointsEarned": "Amanqaku Afunyenweyo",
  'scansuccess.continue': 'Qhubeka',
  "profile.completeTitle": "Gqibezela Iprofayili Yakho",
  "profile.completeSubtitle": "Fumana {points} amanqaku ebhonasi!",
  "profile.completedTitle": "Iprofayili Iqinisekisiwe! ✓",
  "profile.completedSubtitle": "Ufumene onke {points} amanqaku ebhonasi!",
  "profile.completeButton": "Gqibezela Iprofayili (+{points} pt)",
  "profile.redeem": "✓ Iprofayili Iqinisekisiwe",
  "product.review.placeholder": "Bhala uphononongo... (uchwethezo olunye luyanele)",
  "product.review.ariaLabel": "Bhala uphononongo",
  "profile.field.phoneNo.label": "Inombolo yefowuni",
  "profile.field.phoneNo.add": "Yongeza inombolo yakho",
  "profile.field.email.label": "Idilesi ye-imeyile",
  "profile.field.email.add": "Yongeza i-imeyile yakho",
  "profile.field.countryCode.label": "Indawo",
  "profile.field.countryCode.add": "Yongeza indawo yakho",
  "profile.field.name.label": "Igama",
  "profile.field.name.add": "Yongeza igama lakho",
  "profile.field.dateOfBirth.label": "Usuku lokuzalwa",
  "profile.field.dateOfBirth.add": "Yongeza usuku lwakho lokuzalwa",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Hlaziya {field}",
  "profile.modal.completeTitle": "Gqibezela Iprofayili Yakho",
  "profile.modal.update": "Hlaziya",
  "profile.modal.complete": "Gqibezela Iprofayili",
  "profile.modal.cancel": "Khansela",
  "profile.completedBadge": "Ufumene amanqaku {points}",
  "profile.progressPercent": "{percent}% Iqediwe",
  "profile.progressRemaining": "{percent}% eseleyo",
  'scansuccess.congratulations.heading': 'Halala!',
  'scansuccess.congratulations.continue': 'Ufumene',
  'scansuccess.congratulations.select-product': 'Enkosi ngolwazi lwakho',
  'scansuccess.congratulations.review-products': 'Ukuze ufumane amanqaku amaninzi, linganisa iimveliso ezininzi ozenzileyo kuthi',
  'scansuccess.congratulations.create': 'Yiya kuDashboard',
  'user.brand-product-review.title': 'Khetha uBrand & Product Ukuqhubeka',
  'user.brand-product-review.continue': 'Qhubeka',
  'user.brand-product-review.select-product': 'Khetha imveliso ukuze uqhubeke',
  'user.brand-product-review.review-products': 'Bukeza iimveliso zethu ukufumana amanqaku',
  'user.brand-product-review.rate-product': 'Nceda linganisela ubuncinci imveliso enye apha ngasentla ukuze uqhubeke',
  'user.brand-product-review.footer': '© {year} Powered by Exceptional Brands',
  'scansuccess.title': 'Iziphumo zokuqhafaza',
  'scansuccess.scan.message': 'Enkosi — iskena lakho liphumelele.',
  'scansuccess.scan.instructions': 'Ungafaka amanqaku, ubhale uphononongo okanye ubhalisele izibonelelo.',
  'scansuccess.signup.title': 'Bhalisa ukuze ufumane imiklomelo',
  'scansuccess.signup.button': 'Bhalisa',
  'scansuccess.welcomepoints.title': 'Amanqaku Okwamkela',
  'scansuccess.welcomepoints.pointsLabel': 'Amanqaku anikwe',
  'scansuccess.brandproductreview.title': 'Uphononongo lweBrand & Product',
  'scansuccess.brandproductreview.leaveReview': 'Shiya uphononongo',
  'scansuccess.productreview.title': 'Uphononongo lweMveliso',
  'scansuccess.productreview.submit': 'Thumela Uphononongo',
  'scansuccess.congratulations.title': 'Halala!',
  'scansuccess.congratulations.message': 'Ufumene amanqaku — jonga i-dashboard yakho ukuwacebisa.',
  'scansuccess.noAccount': 'Awunayo iakhawunti?',
  'scansuccess.signup': 'Bhalisa',

  "user.register.createProfile": "Yenza iAkhawunti",
  "user.register.creatingProfile": "Kudala iAkhawunti...",
  "user.register.termsOfService": "Imigaqo yenkonzo",
  "user.register.privacyPolicy": "Inqubomgomo yokubuyekeza",

  'dashboard.multiplescans.title': 'Iscans ezininzi',
  'dashboard.multiplescans.instructions': 'Lawula izcan ezininzi kunye nemiklomelo ndawonye.',
  'dashboard.title': 'Wamkelekile!',
  'dashboard.balance': 'Ibhalansi yakho',
  'dashboard.balance-sub': 'amanqaku',
  'dashboard.redeem': 'Faka isicelo',
  'dashboard.stat': 'Iscans iyonke',
  'dashboard.label': 'Imiklomelo ephunyeziweyo',
  'dashboard.redeem.title': 'Faka isicelo samaphuzu akho',
  'dashboard.redeem.success': 'Faka imiklomelo',
  'dashboard.primary-sub': 'Sebenzisa amaphuzu akho ukuvula imiklomelo',
  'dashboard.secondary-btn': 'Skena kwakhona',
  'dashboard.secondary': 'Ncoma uhlobo',
  'dashboard.loyalty': 'Izinga lobuqotho',
  'dashboard.5000pts': '5000 amanqaku',
  'dashboard.100pts': '100 amanqaku ukuya ku-Platinum',
  'dashboard.almost-there': 'Sisondele!',
  'dashboard.recent': 'Imisebenzi yakutshanje',
  'settings.title': 'Useto',
  'settings.balance': 'Ilungu leGOLD',
  'settings.balance-sub': 'Amanqaku',
  'settings.redeem': 'Akhawunti',
  'settings.stat': 'Hlela Iprofayili',
  'settings.label': 'Hlaziya ulwazi lomntu',
  'settings.redeem.title': 'Ukhetho',
  'settings.redeem.success': 'Izaziso',
  'settings.primary-sub': 'Izintandokazi ze-push & i-imeyile',
  'settings.secondary-btn': 'Ulwimi',
  'settings.secondary': 'isiXhosa',
  'settings.loyalty': 'Uncedo & Imigaqo',
  'settings.5000pts': 'Uncedo & Inkxaso',
  'settings.100pts': 'FAQs, qhagamshelana nathi',
  'settings.almost-there': 'Imiqathango & Imigaqo',
  'settings.recent': 'Ulwazi lommthetho',
  'settings.points': 'Inqubomgomo yobumfihlo',
  'settings.data': 'Ulwazi lokukhusela idatha',
  'settings.sign': 'Phuma',

  'profile.balance': '% Iqediwe',
  'profile.balance-sub': '% eseleyo',
  'profile.stat': 'Iinkcukacha zeProfayili',
  'profile.label': 'pt',
  'profile.redeem.title': 'Qhagamshela iiMedia Zenkonzo',
  'profile.redeem.success': 'Fumana amanqaku kuyo yonke iindleko!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Qhagamshela imidiya yakho yokuxhuma ukuze ufumane ibhonasi yamaphuzu ayi-20!',
  'profile.recent': 'Gcwalisa imida ezilandelayo ukugqiba iprofayili yakho kwaye ufumane ',
  

  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "eMzantsi Afrika",
  "country.BJ": "Benin",
  "country.AE": "UAE",

  "dashboard.welcome": "Wamkelekile!",
  "dashboard.user.unknown": "Umsebenzisi",
  "dashboard.balanceLabel": "Ibhalansi yakho",
  "dashboard.coinsAlt": "imali",
  "dashboard.pointsLabel": "amanqaku",
  "dashboard.redeemBtn": "Sebenzisa amaphuzu",
  "dashboard.totalScans": "Iiscans zonke",
  "dashboard.rewardsWon": "Imiklomelo ephunyiweyo",
  "dashboard.redeemTitle": "Faka isicelo samaphuzu akho",
  "dashboard.redeemRewards": "Faka imiklomelo",
  "dashboard.redeemSub": "Sebenzisa amaphuzu akho ukuvula imiklomelo",
  "dashboard.reviewProducts": "Buyekeza iimveliso",
  "dashboard.referFriend": "Ncoma umhlobo",
  "dashboard.tiersTitle": "Izigaba zobufakazi",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "Sisondele!",
  "dashboard.recentActivityTitle": "Imisebenzi yakutshanje",
  "dashboard.share.title": "Joyina Exceptional Brands",
  "dashboard.share.text": "Joyina nami ku-Exceptional Brands! Fumana amaphuzu ngokuskena iimveliso kwaye ufumane imiklomelo emangalisayo. Sebenzisa ikhonkco lam: {url}",
  "dashboard.shareModalTitle": "Yabelana nabahlobo",
  "dashboard.shareModalDesc": "Yabelana nge-Exceptional Brands nabahlobo bakho kwaye ufumane amaphuzu eboniso xa bezojoyina!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Ikhonkco lakho lokudlulisa:",
  "dashboard.share.instagramCopied": "Ikhonkco likopiwe kwi-clipboard - namathisela ku-Instagram",
  "dashboard.footerCopyright": "© {year} Iziphumo ezikhethekileyo",
  "dashboard.aria.welcome": "Iphaneli yokwamkela",
  "dashboard.aria.notifications": "Izaziso",
  "dashboard.aria.settings": "Useto",
  'dashboard.redeem.points': 'Faka amaphuzu akho',
  'dashboard.redeem.subtitle': 'Sebenzisa amaphuzu ukuvula imiklomelo',
  'dashboard.redeem.sub': 'amaphuzu',
  'dashboard.redeem.progress': 'Inqubekela phambili ukuya ku-Platinum',
  'dashboard.redeem.stat': 'Imiklomelo etholakalayo',
  'dashboard.redeem.label': 'Faka isicelo',
  'dashboard.redeem.need': 'Kudingeka',
  'dashboard.redeem.prize': 'Landa umklomelo',
  'dashboard.redeem.scan': 'Ngokwakho uskena ngakumbi uya kukhuphuka amathuba okuwina into emangalisayo',
  'dashboard.redeem.recent': 'Imisebenzi yakutshanje',
  'global.back': 'Buyela',
  'global.next': 'Okulandelayo',
  'global.search.placeholder': 'Khangela...',
  'validation.required': 'Lo mhlaba uyafuneka',
  'error.404.title': 'Iphepha alifumaneki',
  'error.404.subTitle': 'Uxolo, asikwazi ukufumana iphepha olifunayo.',
};
